import * as actions from "../actions/AbstractActions";
import { AbstractState, initialState } from "../store/AbstractState";
import buildReducer from "../utils/ReducerBuilder";

export const AbstractReducer = buildReducer<AbstractState>(initialState)
    .handle(actions.onEventAbstractsSubscribed, (state, action) => {
        if (!action.payload)
            return state;

        const subscribedEventAbstracts = { ...state.subscribedEventAbstracts };
        if (!action.payload.subscribed)
            delete subscribedEventAbstracts[action.payload.id];
        else if (action.payload.subscribed)
            subscribedEventAbstracts[action.payload.id] = 0;
        console.log("subscribed event abstracts", subscribedEventAbstracts);

        return {
            ...state,
            subscribedEventAbstracts,
        };
    })
    .handle(actions.onEventAbtractsUpdatedRemotely, (state, action) => {
        const subscribedEventAbstracts = { ...state.subscribedEventAbstracts };
        subscribedEventAbstracts[action.payload || 0] = new Date().valueOf();
        console.log("subscribed event abstracts", subscribedEventAbstracts);

        return {
            ...state,
            subscribedEventAbstracts,
        };
    })
    .handle(actions.onEventsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            events: action.payload,
        };
    })
    .handle(actions.onTypesUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            types: action.payload,
        };
    })
    .handle(actions.onUserAbstractsSubscribed, (state, action) => {
        if (!action.payload)
            return state;

        const subscribedUserAbstracts = { ...state.subscribedUserAbstracts };
        if (!action.payload.subscribed)
            delete subscribedUserAbstracts[action.payload.id];
        else if (action.payload.subscribed)
            subscribedUserAbstracts[action.payload.id] = 0;
        console.log("subscribed user abstracts", subscribedUserAbstracts);

        return {
            ...state,
            subscribedUserAbstracts,
        };
    })
    .handle(actions.onUserAbstractsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userAbstracts: action.payload,
        };
    })
    .handle(actions.onUserAbtractsUpdatedRemotely, (state, action) => {
        const subscribedUserAbstracts = { ...state.subscribedUserAbstracts };
        subscribedUserAbstracts[action.payload || 0] = new Date().valueOf();
        console.log("subscribed user abstracts", subscribedUserAbstracts);

        return {
            ...state,
            subscribedUserAbstracts,
        };
    })
    .handle(actions.toggleLoadingAbstract, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingAbstract = { ...state.loadingAbstract };
        loadingAbstract[action.payload.abstractId] = action.payload.loading;

        return {
            ...state,
            loadingAbstract,
        };
    })
    .handle(actions.toggleLoadingEvents, (state, action) => ({
        ...state,
        loadingEvents: action.payload || false,
    }))
    .handle(actions.toggleLoadingEventType, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingEventType = { ...state.loadingEventType };
        loadingEventType[action.payload.eventId] = action.payload.loading;

        return {
            ...state,
            loadingEventType,
        };
    })
    .handle(actions.toggleLoadingUserAbstracts, (state, action) => ({
        ...state,
        loadingUserAbstracts: action.payload || false,
    }))
    .handle(actions.toggleMediaProcessing, (state, action) => {
        if (action.payload === undefined)
            return state;

        const mediaProcessing = { ...state.mediaProcessing };
        mediaProcessing[action.payload.mediaId] = action.payload.processing;

        return {
            ...state,
            mediaProcessing,
        };
    })
    .handle(actions.toggleLoadingType, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingType = { ...state.loadingType };
        loadingType[action.payload.typeId] = action.payload.loading;

        return {
            ...state,
            loadingType,
        };
    })
    .handle(actions.websocketUpdated, (state, action) => ({
        ...state,
        websocket: action.payload || state.websocket,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AbstractReducer.ts